import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import PublicPage from "@/pages/PublicPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFoundPage from "@/pages/NotFoundPage";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import LegalPage from "@/pages/LegalPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/teddyfuezing/davidsidea" element={<AdminLogin />} />
          <Route path="/teddyfuezing/davidsidea/dashboard" element={<AdminDashboard />} />
          {/* Legacy redirects */}
          <Route path="/admin" element={<Navigate to="/teddyfuezing/davidsidea" replace />} />
          <Route path="/admin/dashboard" element={<Navigate to="/teddyfuezing/davidsidea/dashboard" replace />} />
          <Route path="/Davidsidea" element={<Navigate to="/teddyfuezing/davidsidea" replace />} />
          <Route path="/Davidsidea/dashboard" element={<Navigate to="/teddyfuezing/davidsidea/dashboard" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
      </CartProvider>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
